import React, { FC } from "react";
import {
  Create,
  CreateProps,
  FormTab,
  TabbedForm,
  useNotify,
  useRefresh,
} from "react-admin";
import { makeUpWinnersRequest } from "../../helpers/winnerRequest";
import dataProvider from "../../providers/dataProvider";
import { WinnerCreateData } from "../../types/winnerRequest";
import DocumentTitleSettings from "../common/documentTitle/DocumentTitleSettings";
import StaffUserFormToolbar from "../staff/StaffUserFormToolBar";
import DescriptionTabForm from "./DescriptionTabForm";
import FormInstruction from "./FormInstructions";

import "./index.css";

const CreateWinner: FC<CreateProps> = (props) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const onSuccess = () => async (data) => {
    // data.photoUrl.rawFile.size > 500000  -> show error

    if (data.photoUrl && data.photoUrl.rawFile) {
      if (data.photoUrl.rawFile.size > 500000) {
        notify("Photo size more then 500kb", "error");
        return;
      }
    }
    // data.winnerPhotoUrl.rawFile.size > 500000  -> show error
    if (data.winnerPhotoUrl && data.winnerPhotoUrl.rawFile) {
      if (data.winnerPhotoUrl.rawFile.size > 500000) {
        notify("Winner photo size more then 500kb", "error");
        return;
      }
    }

    const winnerData: WinnerCreateData = {
      drawDate: data.drawDate,
      name: data.name,
      ...data,
    };
    const multipartData = makeUpWinnersRequest(winnerData);
    const result = await dataProvider.create("winners", {
      data: multipartData,
    });
    if (!result.data) {
      notify("something went wrong", "error");
    }
    notify(`Winner saved`);
    refresh();
  };

  const validateWinner = (value?: any) => {
    if (!value) {
      return undefined;
    }

    const errors: any = {};

    if (!value.prizeTitle) {
      errors.prizeTitle = "Prize is required";
    }

    if (!value.prizeLabel) {
      errors.prizeLabel = "Prize label is required";
    }

    if (!value.prizeType) {
      errors.prizeType = "Prize type is required";
    }

    if (!value.winnerPhotoUrl && !value.videoUrl) {
      errors.winnerPhotoUrl = "Please choose photo.";

      errors.videoUrl =
        "Please choose video url or upload a photo. At least something should be chosen";
    }

    return Object.keys(errors).length ? errors : undefined;
  };

  return (
    <>
      <DocumentTitleSettings core="Winners" purpose="Add new winner" />
      <FormInstruction />
      <Create {...props}>
        <TabbedForm
          toolbar={<StaffUserFormToolbar onSuccess={onSuccess()} {...props} />}
          validate={validateWinner}
        >
          <FormTab label="Description">
            <DescriptionTabForm {...props} />
          </FormTab>
        </TabbedForm>
      </Create>
    </>
  );
};

export default CreateWinner;
